export const reportId = 'report-1';
export const maxScore = 1;
